import React from 'react';
import { useDispatch } from 'react-redux';
import { deleteColumn_Check, setColumn_Check, setColumn_Check_Candidate } from '../../../redux/actions/backendActions';
import { Button, Menu, MenuItem } from '@material-ui/core';
import _Menu from '../../../system/access/images/ats/menu.png';

const PopupContainer = (props) => {
  const { id, onEdit, edit, onRemove, sendable, open, inputcheck } = props;
  const { index, Total } = sendable;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const dispatch = useDispatch();
  // const columns = useSelector(state => state.vacancy.columns);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  //
  const multiSelect = () => {
    if (inputcheck) {
      dispatch(deleteColumn_Check());
    } else {
      dispatch(setColumn_Check(id));
    }
  };

  // const Select_Total_Candidate = () => {
  //     // console.log(id)
  //     // console.log(columns[id])
  //     let Array_Temp = []
  //     columns[id].map(o => {
  //         Array_Temp.push({"idUser": o.docID})
  //     })
  //     dispatch(Post_Multi_Candidate(Array_Temp))
  // }

  const multiSelectCandidate = () => {
    if (inputcheck) {
      dispatch(setColumn_Check_Candidate());
    } else {
      dispatch(setColumn_Check_Candidate(true));
    }
  };

  return (
    <div>
      <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
        <img src={_Menu} alt="Open menu" />
      </Button>
      <Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
        {edit === 'candidates' ? (
          <div>
            {/*<MenuItem onClick={e => {*/}
            {/*    handleClose();*/}
            {/*    multiSelectCandidate();*/}
            {/*}}>*/}
            {/*    {inputcheck ? "Cerrar Multi Select" : "Multi Select"}*/}
            {/*</MenuItem>*/}
            {
              // inputcheck
              //     ?
              //     <MenuItem onClick={e => {
              //         handleClose(e)
              //         // Select_Total_Candidate()
              //     }}>Seleccionar Todos</MenuItem>
              //     :
              //     null
            }
          </div>
        ) : (
          <div>
            {/*<MenuItem onClick={(e) => {*/}
            {/*    handleClose(e)*/}
            {/*    open(sendable)*/}
            {/*}}>Administrar</MenuItem>*/}
            {edit === false ? (
              <div>
                <MenuItem
                  onClick={(e) => {
                    handleClose(e);
                    onEdit(id);
                  }}>
                  Editar Nombre
                </MenuItem>
                {/*<MenuItem onClick={e => {*/}
                {/*    handleClose();*/}
                {/*    multiSelect();*/}
                {/*}}>*/}
                {/*    {inputcheck ? "Cerrar Multi Select" : "Multi Select"}*/}
                {/*</MenuItem>*/}
                {/*{inputcheck*/}
                {/*    ?*/}
                {/*    <MenuItem onClick={e => {*/}
                {/*        handleClose(e)*/}
                {/*        Select_Total_Candidate()*/}
                {/*    }}>Seleccionar Todos</MenuItem>*/}
                {/*    :*/}
                {/*    null*/}
                {/*}*/}
                <MenuItem
                  onClick={(e) => {
                    handleClose(e);
                    onRemove(id);
                  }}>
                  Eliminar
                </MenuItem>
              </div>
            ) : null}
          </div>
        )}
      </Menu>
    </div>
  );
};

export default PopupContainer;
